function language() {
  const urlParams = new URLSearchParams(window.location.search);
  const defaultLanguage = 'en';
  return (
    urlParams.get('language') ||
    console.warn(`using ${defaultLanguage} as default for missing query param 'language'`) ||
    defaultLanguage
  );
}
let LocalizedString = {};
let lang = language();
LocalizedString.language = lang;
LocalizedString['Error Header'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'Whoops!';
    case 'ko':
      return '앗, 이런!';
    case 'ja':
      return 'Whoops!';
    default:
      return 'Whoops!';
  }
};
LocalizedString['Error Section p1'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return "Looks like we lost our connection. Let's get this sorted out.";
    case 'ko':
      return '팁 서비스의 연결이 끊겼습니다. 아래 사항들을 확인해 주시기 바랍니다.';
    case 'ja':
      return "Looks like we lost our connection. Let's get this sorted out.";
    default:
      return "Looks like we lost our connection. Let's get this sorted out.";
  }
};
LocalizedString['Error Section p2'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'Try these quick fixes:';
    case 'ko':
      return '';
    case 'ja':
      return 'Try these quick fixes:';
    default:
      return 'Try these quick fixes:';
  }
};
LocalizedString['Error Bullets 2'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'Make sure your Location Services are enabled';
    case 'ko':
      return "스마트폰 '위치 서비스' 활성화 여부 확인";
    case 'ja':
      return 'Make sure your Location Services are enabled';
    default:
      return 'Make sure your Location Services are enabled';
  }
};
LocalizedString['Error Bullets 1'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'Check your Wi-Fi Connection';
    case 'ko':
      return '인터넷 연결 상태 확인';
    case 'ja':
      return 'Check your Wi-Fi Connection';
    default:
      return 'Check your Wi-Fi Connection';
  }
};
LocalizedString['Error Section p3'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'Still no luck? Reach out to us for personal support.';
    case 'ko':
      return '그래도 문제 해결이 안 된다면 AWAIR 고객 센터로  바랍니다.';
    case 'ja':
      return 'Still no luck? Reach out to us for personal support.';
    default:
      return 'Still no luck? Reach out to us for personal support.';
  }
};
LocalizedString['Contact Support'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'Contact Support';
    case 'ko':
      return 'AWAIR 고객 센터';
    case 'ja':
      return 'Contact Support';
    default:
      return 'Contact Support';
  }
};
LocalizedString['Support Link'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'https://support.getawair.com/hc/en-us';
    case 'ko':
      return 'https://support.getawair.com/hc/ko';
    case 'ja':
      return 'https://support.getawair.com/hc/en-us';
    default:
      return 'https://support.getawair.com/hc/en-us';
  }
};
LocalizedString['Learn More'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'Learn More';
    case 'ko':
      return '더 알아보기';
    case 'ja':
      return 'Learn More';
    default:
      return 'Learn More';
  }
};
LocalizedString['Browse Favorites'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return 'Browse our Favorites';
    default:
      return 'Browse our Favorites';
  }
};
LocalizedString['Your room had good air for ()% of last week'] = (percent) => {
  switch (LocalizedString.language) {
    case 'en':
      return `Your room had good air for ${percent}% of last week`;
    case 'jp':
      return `先週の${percent}%が良好な空気でした`;
    case 'ko':
      return `이 방은 지난 주의 ${percent}%를 좋은 공기질로 유지했습니다.`;
    default:
      return `Your room had good air for ${percent}% of last week`;
  }
};
LocalizedString['7 Day Summary'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `7 Day Summary`;
    case 'jp':
      return `週間まとめ`;
    case 'ko':
      return `일주일 요약`;
    default:
      return `7 Day Summary`;
  }
};
LocalizedString['Good'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `Good`;
    case 'jp':
      return `良好`;
    case 'ko':
      return `좋음`;
    default:
      return `Good`;
  }
};
LocalizedString['Fair'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `Fair`;
    case 'jp':
      return `普通`;
    case 'ko':
      return `보통`;
    default:
      return `Fair`;
  }
};
LocalizedString['Poor'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `Poor`;
    case 'jp':
      return `標準以下`;
    case 'ko':
      return `나쁨`;
    default:
      return `Poor`;
  }
};
LocalizedString['Unknown'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `Unknown`;
    case 'jp':
      return `なし`;
    case 'ko':
      return `미측정`;
    default:
      return `Unknown`;
  }
};
LocalizedString['H'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `H`;
    case 'jp':
      return `h`;
    case 'ko':
      return `h`;
    default:
      return `H`;
  }
};
LocalizedString['Your (a) may be as high as (b) (c) and as low as (d) (e) tomorrow'] = (a, b, c, d, e) => {
  switch (LocalizedString.language) {
    case 'en':
      return `Your ${a} may be as high as ${b} ${c} tomorrow, and as low as ${d} ${e}`;
    case 'jp':
      return `${a}は明日最高${b}${c}まで上がり最低${d}${e}まで下がりそうです`;
    case 'ko':
      return `${a} 수치는 내일 최고 ${b} ${c} 에서 최저 ${d} ${e} 로 예상됩니다`;
    default:
      return `Your ${a} may be as high as ${b} ${c} tomorrow, and as low as ${d} ${e}`;
  }
};
LocalizedString['So far, your average (a) today (b) (c) (d) lower than yesterday'] = (a, b, c, d) => {
  switch (LocalizedString.language) {
    case 'en':
      return `So far, your average ${a} today ${b} ${c} ${d} lower than yesterday`;
    case 'jp':
      return `現時点で今日の${a}の平均は昨日より${c}${d}低いです`;
    case 'ko':
      return `오늘의 평균 ${a} 수치는 어제보다 ${c} ${d} 더 낮습니다`;
    default:
      return `So far, your average ${a} today ${b} ${c} ${d} lower than yesterday`;
  }
};
LocalizedString['So far, your average (a) today (b) the same as yesterday'] = (a, b) => {
  switch (LocalizedString.language) {
    case 'en':
      return `So far, your average ${a} today ${b} the same as yesterday`;
    case 'jp':
      return `現時点で今日の${a}の平均は昨日と同じです`;
    case 'ko':
      return `오늘의 평균 ${a} 수치는 어제와 같습니다`;
    default:
      return `So far, your average ${a} today ${b} the same as yesterday`;
  }
};
LocalizedString['So far, your average (a) today (b) (c) (d) higher than yesterday'] = (a, b, c, d) => {
  switch (LocalizedString.language) {
    case 'en':
      return `So far, your average ${a} today ${b} ${c} ${d} higher than yesterday`;
    case 'jp':
      return `現時点で今日の${a}の平均は昨日より${b} ${c}高いです`;
    case 'ko':
      return `오늘의 평균 ${a} 수치는 어제보다 ${c} ${d} 더 높습니다`;
    default:
      return `So far, your average ${a} today ${b} ${c} ${d} higher than yesterday`;
  }
};
LocalizedString['Today'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `Today`;
    case 'jp':
      return `今日`;
    case 'ko':
      return `오늘`;
    default:
      return `Today`;
  }
};
LocalizedString['Yesterday'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `Yesterday`;
    case 'jp':
      return `昨日`;
    case 'ko':
      return `어제`;
    default:
      return `Yesterday`;
  }
};
LocalizedString['temperature'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `temperature`;
    case 'jp':
      return `温度`;
    case 'ko':
      return `온도`;
    default:
      return `temperature`;
  }
};
LocalizedString['humidity'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `humidity`;
    case 'jp':
      return `湿度`;
    case 'ko':
      return `습도`;
    default:
      return `humidity`;
  }
};
LocalizedString['CO₂'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `CO₂`;
    case 'jp':
      return `酸化炭素`;
    case 'ko':
      return `이산화탄소`;
    default:
      return `CO₂`;
  }
};
LocalizedString['chemicals'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `chemicals`;
    case 'jp':
      return `化学物質`;
    case 'ko':
      return `화학물질`;
    default:
      return `chemicals`;
  }
};
LocalizedString['dust'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `dust`;
    case 'jp':
      return `ホコリ`;
    case 'ko':
      return `미세먼지`;
    default:
      return `dust`;
  }
};
LocalizedString['PM2.5'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `PM2.5`;
    case 'jp':
      return `PM2.5`;
    case 'ko':
      return `초미세먼지`;
    default:
      return `PM2.5`;
  }
};
LocalizedString['PM10'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `PM10`;
    case 'jp':
      return `PM10`;
    case 'ko':
      return `미세먼지`;
    default:
      return `PM10`;
  }
};
LocalizedString['Awair Score'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `Awair Score`;
    case 'jp':
      return `Awairスコア`;
    case 'ko':
      return `Awair 스코어`;
    default:
      return `Awair Score`;
  }
};
LocalizedString['degree Celsius'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `°C`;
    case 'jp':
      return `摂氏`;
    case 'ko':
      return `섭씨`;
    default:
      return `°C`;
  }
};
LocalizedString['degrees Celsius'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `°C`;
    case 'jp':
      return `摂氏`;
    case 'ko':
      return `섭씨`;
    default:
      return `°C`;
  }
};
LocalizedString['degree Fahrenheit'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `°F`;
    case 'jp':
      return `華氏`;
    case 'ko':
      return `화씨`;
    default:
      return `°F`;
  }
};
LocalizedString['degrees Fahrenheit'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `°F`;
    case 'jp':
      return `華氏`;
    case 'ko':
      return `화씨`;
    default:
      return `°F`;
  }
};
LocalizedString['%RH'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `%RH`;
    case 'jp':
      return `%RH`;
    case 'ko':
      return `%RH`;
    default:
      return `%RH`;
  }
};
LocalizedString['ppm'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `ppm`;
    case 'jp':
      return `ppm`;
    case 'ko':
      return `ppm`;
    default:
      return `ppm`;
  }
};
LocalizedString['ppb'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `ppb`;
    case 'jp':
      return `ppb`;
    case 'ko':
      return `ppb`;
    default:
      return `ppb`;
  }
};
LocalizedString['µg/m³'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `µg/m³`;
    case 'jp':
      return `µg/m³`;
    case 'ko':
      return `µg/m³`;
    default:
      return `µg/m³`;
  }
};
LocalizedString['point'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `point`;
    case 'jp':
      return `点`;
    case 'ko':
      return `점`;
    default:
      return `point`;
  }
};
LocalizedString['points'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `points`;
    case 'jp':
      return `点`;
    case 'ko':
      return `점`;
    default:
      return `points`;
  }
};
LocalizedString['Fine Dust'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `Fine Dust`;
    case 'jp':
      return `微細なホコリ`;
    case 'ko':
      return `미세먼지`;
    default:
      return `Fine Dust`;
  }
};
LocalizedString['is'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `is`;
    case 'jp':
      return ``;
    case 'ko':
      return ``;
    default:
      return `is`;
  }
};
LocalizedString['are'] = () => {
  switch (LocalizedString.language) {
    case 'en':
      return `are`;
    case 'jp':
      return ``;
    case 'ko':
      return ``;
    default:
      return `are`;
  }
};

export default LocalizedString;
